import {Container} from "reactstrap";
import {Helmet} from "react-helmet";

export default function UserInfo()
{
    return (<Container className="mb-5">
        <Helmet>
            <title>Политика конфиденциальности</title>
            <meta name="description" content="Политика конфиденциальности и согласие на обработку персональных данных интернет-магазина ICandy" />
        </Helmet>
        <h1>Политика конфиденциальности</h1>

        <h2>1. Общие положения</h2>
        <p>Настоящая Политика конфиденциальности (далее — Политика) определяет порядок обработки и защиты персональных данных пользователей сайта <strong>icandy.online</strong> (далее — Сайт) в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
        <p>Используя Сайт, заполняя форму обратной связи или оформляя заказ, Пользователь выражает своё согласие с условиями настоящей Политики. Если Вы не согласны с условиями Политики — не используйте Сайт и не передавайте свои данные.</p>

        <h2>2. Состав собираемых данных</h2>
        <p>Администрация Сайта собирает следующие персональные данные Пользователя:</p>
        <ul>
            <li>Имя;</li>
            <li>Номер телефона;</li>
            <li>Адрес электронной почты (при регистрации);</li>
            <li>Текст сообщения или комментария к заказу;</li>
            <li>Наименование товара, по которому поступил запрос.</li>
        </ul>
        <p>Автоматически собираются технические данные: IP-адрес, тип браузера, данные файлов cookie, история посещений страниц (с помощью Яндекс.Метрики и других систем веб-аналитики).</p>

        <h2>3. Цели обработки персональных данных</h2>
        <p>Персональные данные обрабатываются в следующих целях:</p>
        <ul>
            <li>Обработка заявок на обратный звонок и консультирование по товарам;</li>
            <li>Оформление и выполнение заказов;</li>
            <li>Информирование о статусе заказа и условиях доставки;</li>
            <li>Улучшение качества обслуживания и работы Сайта;</li>
            <li>Проведение маркетинговых исследований и аналитики (при отдельном согласии).</li>
        </ul>

        <h2>4. Правовые основания обработки</h2>
        <p>Обработка персональных данных осуществляется на основании:</p>
        <ul>
            <li>ст. 6 Федерального закона № 152-ФЗ «О персональных данных»;</li>
            <li>согласия Пользователя, выраженного путём заполнения формы обратной связи и нажатия кнопки «Заказать звонок».</li>
        </ul>

        <h2>5. Порядок обработки и хранения</h2>
        <p>Администрация Сайта обеспечивает сохранность персональных данных и принимает необходимые организационные и технические меры для их защиты от неправомерного доступа, уничтожения, изменения, блокирования, копирования и распространения.</p>
        <p>Персональные данные хранятся в течение срока, необходимого для достижения целей обработки, но не дольше 3 лет с момента последнего обращения Пользователя, если иное не предусмотрено законодательством РФ.</p>

        <h2>6. Передача данных третьим лицам</h2>
        <p>Администрация Сайта не передаёт персональные данные третьим лицам, за исключением случаев:</p>
        <ul>
            <li>предусмотренных действующим законодательством РФ;</li>
            <li>для обработки и доставки заказа (службы доставки, платёжные системы);</li>
            <li>при использовании сторонних сервисов аналитики (Яндекс.Метрика).</li>
        </ul>

        <h2>7. Права Пользователя</h2>
        <p>Пользователь имеет право:</p>
        <ul>
            <li>получить информацию о том, какие персональные данные хранятся и как они обрабатываются;</li>
            <li>требовать уточнения, блокирования или уничтожения своих персональных данных;</li>
            <li>отозвать согласие на обработку персональных данных в любой момент, направив уведомление на электронную почту <a href="mailto:Icandy.eurasia@gmail.com">Icandy.eurasia@gmail.com</a>;</li>
            <li>обжаловать действия Администрации в уполномоченном органе по защите прав субъектов персональных данных.</li>
        </ul>

        <h2>8. Согласие на обработку персональных данных</h2>
        <p>Заполняя форму «Заказать звонок» на Сайте и нажимая кнопку отправки, Пользователь <strong>безоговорочно принимает</strong> настоящее Согласие на обработку персональных данных.</p>
        <p>Согласие даётся на следующие действия: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (в соответствии с п. 6 Политики), обезличивание, блокирование, удаление и уничтожение персональных данных.</p>
        <p>Согласие действует с момента заполнения формы до его отзыва Пользователем в порядке, предусмотренном п. 7 Политики.</p>

        <h2>9. Заключительные положения</h2>
        <p>Администрация Сайта оставляет за собой право вносить изменения в настоящую Политику без предварительного уведомления Пользователей. Новая версия Политики вступает в силу с момента её размещения на Сайте, если иное не предусмотрено новой версией.</p>
        <p>По всем вопросам, связанным с обработкой персональных данных, Пользователь может обратиться по электронной почте: <a href="mailto:Icandy.eurasia@gmail.com">Icandy.eurasia@gmail.com</a>.</p>

        <p className="mt-5 text-muted small">Последнее обновление: июль 2026 г.</p>
    </Container>)
}
